import { FC, ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import styles from './checkbox.module.scss';

/**
 * Properties.
 */
type Props = Omit<ComponentPropsWithoutRef<'input'>, 'className'> & {
    /**
     * is some of checkboxes checked?.
     */
    partlyChecked?: boolean;
};

/**
 * Custom checkbox component.
 * @param partlyChecked is some of checkboxes checked?.
 */
const Checkbox: FC<Props> = ({ children, partlyChecked, ...props }) => {
    return (
        <label className={classNames(styles.checkbox)}>
            <span className={classNames(styles.box, styles.noShrink)}>
                <input className={styles.input} type="checkbox" {...props} />
                <span className={classNames(styles.customViewBase, { [styles.partlyChecked]: partlyChecked })} />
            </span>
            {children && <span className={styles.title}>{children}</span>}
        </label>
    );
};

export default Checkbox;
